import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
//import pages
import Header from "./components/header/header";
import Home from "./pages/home";
import About from "./pages/about";
import Portfolio from "./pages/portfolio";
import Services from "./pages/services";
import Partners from "./pages/partners";
import Footer from "./components/footer/footer";
//import main styles
import "./App.scss";
import Sky from "./components/sky/sky";
import Parallax from "./components/parallax/parallax";

function App() {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Sky />
      <Parallax></Parallax>
      <Header lang={lang} setLang={setLang} />
      <Routes>
        <Route path="/" element={<Home lang={lang} />} />
        <Route path="/home" element={<Home lang={lang} />} />
        <Route path="/about-us" element={<About lang={lang} />} />
        <Route path="/portfolio" element={<Portfolio lang={lang} />} />
        <Route path="/services" element={<Services lang={lang} />} />
        <Route path="/partners" element={<Partners lang={lang} />} />
      </Routes>
      <Footer lang={lang} />
    </BrowserRouter>
  );
}

export default App;
